import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaPerformanceFeeMenuRegistry = {
    personalize_nebulaPerformanceFee: {
        label: "Nebula Performance Fee",
        link: PAGE_URL.NEBULA_PERFORMANCE_FEE_PAGE,
        key: PAGE_URL.NEBULA_PERFORMANCE_FEE_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaPerformanceFeeMenuRegistry;
